import * as v from 'valibot';

import { newSchema } from '../../utils/valibot/schema';
import { Translation } from '../library/translation';

export const TranslationSchema: v.GenericSchema<Translation> = newSchema(
  'TranslationSchema',
  v.record(
    v.string(),
    v.lazy(() => TranslationValueSchema),
  ),
);

export const TranslationValueSchema = newSchema('TranslationValueSchema', v.union([v.string(), TranslationSchema]));
